import countryCodes from '../../assets/json/countryCodes.json';
import { alphabetSort } from '../../utils/utils';

const useCountryCodes = () => countryCodes.map(c=>({name:c.name, cca2:c.cca2, phoneCode:c.phoneCode, id:c.cca2}));


export default useCountryCodes;